import {ConfigObjectType, useLocalStorage} from '@wallaby-ui/core';
import {HaidiSchema, encounterContainer, useFormatters} from '@wallaby-ui/document';
import {parseISO} from 'date-fns';
import * as React from 'react';
import {useMemo} from 'react';
import {Tab, TabList, TabPanel, Tabs} from 'react-tabs';

import {EncounterDocumentList} from './documentList/EncounterDocumentList';
import {EncounterHaiList} from './hai/EncounterHaiList';
import stylesLayout from '../AppLayout.less';

interface OwnProps {
  config: ConfigObjectType;
  documentId: string;
  encounterId: string;
  encounterData: HaidiSchema.components['schemas']['EncounterPropertiesDto'] | undefined;
  onlyProperties?: boolean;
  storageIdPrefix: string;
  query: any;
  changeQuery: (newValue: any) => void;
}

type Props = OwnProps;

export const EncounterLayoutTabs: React.FC<Props> = (props) => {
  const {config, documentId, encounterId, encounterData, onlyProperties, storageIdPrefix, query, changeQuery} = props;

  const {t} = useFormatters();

  const PROPERTIES_TAB_INDEX = 2;
  const defaultTabIndex = useMemo(() => {
    if (encounterId) {
      return documentId ? 0 : 1;
    }
    return PROPERTIES_TAB_INDEX;
  }, [encounterId, documentId]);

  const [tabIndex, _, setTabIndex] = useLocalStorage(`${storageIdPrefix}.tabIndex`, defaultTabIndex);

  const handleTabSelect = (tabIdx: number) => {
    if (!onlyProperties) setTabIndex(tabIdx);
  };

  return (
    <Tabs
      className={{
        'react-tabs': true,
        [stylesLayout.dlTabsColumn]: true,
        [stylesLayout.dlFlexColumn]: true,
      }}
      selectedIndex={onlyProperties ? PROPERTIES_TAB_INDEX : tabIndex}
      onSelect={handleTabSelect}
      selectedTabPanelClassName={stylesLayout.dlSelectedTab}
      forceRenderTabPanel
    >
      <TabList
        className={{
          [stylesLayout.dlTabList]: true,
          [stylesLayout.dlHidden]: false,
        }}
      >
        <Tab disabled={onlyProperties}>
          <span data-name={'tab-tabs.tab.case.documents'}>{t('tabs.tab.case.documents')}</span>
        </Tab>
        <Tab disabled={onlyProperties}>
          <span data-name={'tab-tabs.tab.case.hai'}>{t('tabs.tab.case.hai')}</span>
        </Tab>
        <Tab>
          <span data-name={'tab-tabs.tab.case.properties'}>{t('tabs.tab.case.properties')}</span>
        </Tab>
      </TabList>
      <TabPanel
        className={{
          'react-tabs__tab-panel': true,
          [stylesLayout.dlTabColumn]: true,
          [stylesLayout.dlFlexColumn]: true,
        }}
      >
        {!onlyProperties && (
          <EncounterDocumentList
            encounterId={encounterId}
            encounterStart={parseISO(encounterData?.encounterStartedAt ?? '')}
            encounterEnd={parseISO(encounterData?.encounterEndedAt ?? '')}
            documentId={documentId}
            config={config}
            query={query}
            changeQuery={changeQuery}
          />
        )}
      </TabPanel>
      <TabPanel
        className={{
          'react-tabs__tab-panel': true,
          [stylesLayout.dlTabColumn]: true,
          [stylesLayout.dlFlexColumn]: true,
        }}
      >
        {!onlyProperties &&
          tabIndex === 1 && ( // NOTE: we need to hide hai list for ui-tests
            <EncounterHaiList encounterId={encounterId} />
          )}
      </TabPanel>
      <TabPanel
        className={{
          'react-tabs__tab-panel': true,
          [stylesLayout.dlTabColumn]: true,
          [stylesLayout.dlFlexColumn]: true,
        }}
      >
        <encounterContainer.EncounterDetailProperties
          encounterData={encounterData}
          encounterId={encounterId}
          documentId={documentId}
          config={config}
        />
      </TabPanel>
    </Tabs>
  );
};
